<template>
    <div>
        <Form v-if="auth.screen === 'recovery' || auth.screen === 'login'" @submit.prevent="passwordReset1()">
            <b-row form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <input type="text" v-model="model.username" class="form-control wd-sm-250 flex-fill" placeholder="Enter username">
                    <base-button
                            class="mt-0 ml-2"
                            :loading="auth.authLoading"
                            title="Reset Password"
                    ></base-button>
                </div>
            </b-row>
        </Form>
<!--        <Form v-if="auth.screen === 'recovery2'" @submit.prevent="passwordReset2()">-->
<!--            <b-row form>-->
<!--                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">-->
<!--                    <input type="text" v-model="model.token" class="form-control wd-sm-250 flex-fill" placeholder="Enter OTP">-->
<!--                    <base-button-->
<!--                            class="mt-0 ml-2"-->
<!--                            :loading="auth.authLoading"-->
<!--                            title="Verify Otp"-->
<!--                    ></base-button>-->
<!--                </div>-->
<!--            </b-row>-->
<!--        </Form>-->
        <Form v-if="auth.screen === 'recovery2'" @submit.prevent="passwordReset3()">
            <b-row form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <input type="text" v-model="model.token" class="form-control wd-sm-250 flex-fill" placeholder="Enter OTP">
                </div>
            </b-row>
            <b-row form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <the-mask placeholder="Enter your input 6 Digit Pin..." type="password" required v-model="model.password" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />
<!--                    <input type="password" minlength="6" maxlength="6" v-model="model.password" class="form-control wd-sm-300 flex-fill" placeholder="Enter your password">-->
                </div>
            </b-row>
            <b-row form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <the-mask placeholder="Repeat Pin here..." type="password" required v-model="model.passwordConfirmation" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />
<!--                    <input type="password"  minlength="6"  maxlength="6"  v-model="model.passwordConfirmation" class="form-control wd-sm-300 flex-fill" placeholder="Retype password">-->
                </div>
            </b-row>
            <b-row form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <base-button
                            class="mt-0 wd-sm-300 flex-fill"
                            :loading="auth.authLoading"
                            title="Change Password"
                    ></base-button>
                </div>
            </b-row>
    </Form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import BaseButton from "../button/BaseButton";
    export default {
        name: "ForgotForm",
        components:{BaseButton},
        data() {
            return {
                model: {
                    mobiledeviceid: '716ddd273',
                    username: '',
                    requestid:'716ddd273',
                    source:'MOBILE',
                    devicedetails: '100635ddd8078',
                    uniqueref: '',
                    token: '',
                    password: '',
                    passwordConfirmation: '',
                    pin: '1234',
                    subscribe: true
                },
            }
        },
        methods: {
            async passwordReset1() {
                this.model.dialogs = this.$dialogs
                await this.$store.dispatch("auth/initiateResetPassword", this.model, {root: false})
                this.model.uniqueref = this.auth.response.uniqueref
            },

            async passwordReset2() {
                this.model.dialogs = this.$dialogs
                await this.$store.dispatch("auth/verifyToken", this.model, {root: false})
            },

            async passwordReset3() {
                if (this.model.password !== this.model.passwordConfirmation){
                    const options = {title: 'Info!', size: 'sm'};
                    this.$dialogs.alert('Password Mismatched', options)
                        .then();
                }else {
                    this.model.dialogs = this.$dialogs
                    await this.$store.dispatch("auth/completeResetPassword", this.model, {root: false})
                }
            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),
        },
    }
</script>

<style scoped>

</style>